import { render, staticRenderFns } from "./orderInfoPublic.vue?vue&type=template&id=5f6522d8&scoped=true&"
import script from "./orderInfoPublic.vue?vue&type=script&lang=js&"
export * from "./orderInfoPublic.vue?vue&type=script&lang=js&"
import style0 from "./orderInfoPublic.vue?vue&type=style&index=0&id=5f6522d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6522d8",
  null
  
)

export default component.exports